export enum StatoPlesso {
    abilitato = 'ABILITATO',
    disablitato = 'DISABILITATO'
}
